module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/wt-react/node_modules/axios/index.js
// module id = 1049
// module chunks = 0